import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import style from "./MarkAsCompletedButton.module.css";
import Icon from "@/ui/icon/Icon";
import { useFinishCourse } from "../../hooks/useFinishCourse";
import { useConfettiWithSound } from "@/hooks/useConfettiWithSound";
import certificateToast from "@/features/certificates/components/certificateToast/CertificateToast";
import { useNavigate } from "react-router-dom";
import { useGetCourseCertificate } from "@/features/certificates/hooks/useGetCourseCertificate";

function MarkAsCompletedButton({ course, setShowCertificateToast }) {
	const { t } = useTranslation();
	const [isVisible, setIsVisible] = useState(true);
	const [animate, setAnimate] = useState(false);
	const [clicked, setClicked] = useState(false);
	const buttonRef = useRef(null);

	const { finishCourse } = useFinishCourse({ course });
	const { triggerConfetti, cleanup, soundDuration } = useConfettiWithSound();

	useEffect(() => {
		setAnimate(true);
		return () => {
			cleanup();
		};
	}, [cleanup]);

	const handleClick = async () => {
		if (clicked) return;

		setClicked(true);
		try {
			await Promise.all([finishCourse(), triggerConfetti()]);
			setShowCertificateToast(true);
			setAnimate(false);
			setIsVisible(false);
		} catch (error) {
			console.error("Error:", error);
			setAnimate(false);
			setIsVisible(false);
		}
	};

	return (
		<>
			{isVisible && (
				<div
					ref={buttonRef}
					className={`${style.buttonHolder} ${
						animate ? style.fadeIn : style.fadeOut
					} ${clicked ? style.disabled : ""}`}
				>
					<div
						className={`${style.button} ${
							clicked ? style.clicked : ""
						}`}
						onClick={handleClick}
					>
						<span>{t("courses:markAsCompleted.button")}</span>
						<div className={style.icoHolder}>
							<span className={style.defaultIcon}>
								<Icon icon="fa-eye" />
							</span>
							<span className={style.hoverIcon}>
								<Icon icon="fa-check" />
							</span>
						</div>
					</div>
				</div>
			)}
		</>
	);
}

export default MarkAsCompletedButton;
